import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Brands } from '../util/constants';
import { getSettings } from '../util/getSettings';

const CommunityResult = ({
    company,
    name,
    imageUrl,
    cityStateZip,
    financeInfo,
    url,
    priceOverrideText,
    startingPrice,
    offerFlags,
    isFHA,
    isMortCalcEnabled,
    isHidingMonthlyPayment,
    zipCode,    
    includeCreditScore,
    downPaymentPercentage,
    phone,
    hoaDues
}) => {

    const settings = getSettings(['century', 'settings'], true);
    const labels = getSettings(['century', 'labels'], true);
    const markerDataState = useSelector(state => state.markerData);
    const [monthlyPayment, setMonthlyPayment] = useState("");
    const calcReady = useSelector((state) => state.mortgageCalc.bbReady);
    const ref = useRef();
    const spanEl = useRef(null);
    const cardEl = useRef(null)
    const housePrice = parseInt(financeInfo.price.replace(/,/g, '').replace('$', ''), 10)
    let payment = 0;    
    var hasStartingPrice = "column-normal";
    const phoneNumber = phone.replace(/-/g, ".")

    if(startingPrice===0){
        hasStartingPrice = "column-short"
    }    

    async function main() {
        try {
            if (startingPrice > 0 && housePrice > 0) {

                let options = {};

                if (isFHA) {
                    options = {
                        dpp: 3.5,
                        list_price: housePrice,
                        term: 360,
                        loan_type: "FHA",
                        down_payment: housePrice * downPaymentPercentage,
                        zipcode: zipCode,
                        hoadues: hoaDues
                    };
                } else {
                    options = {
                        dpp: 20,
                        list_price: housePrice,
                        term: 360,						
                        loan_type: "conventional",						
                        down_payment: housePrice * downPaymentPercentage,
                        zipcode: zipCode,
                        hoadues: hoaDues
                    };
                }

                if (includeCreditScore) {
                    options.credit_score = 740;
                }

                let calcResult = await BB.api.loanCalc(options);

                if (isFHA) {
                    payment = Math.floor(calcResult.pi + calcResult.taxes + calcResult.homeInsurance + (calcResult.mortgageInsurance ? calcResult.mortgageInsurance : 0) + hoaDues);

                } else {
                    payment = Math.floor(calcResult.pi + calcResult.taxes + calcResult.homeInsurance + hoaDues);
                }

                setMonthlyPayment(payment);
            }

        } catch (e) {
            console.log("Error: " + e.message);          
        }
    };

    useEffect(() => {
        if (isMortCalcEnabled && calcReady) {
            main();
        }
    }, [calcReady]);

    async function openCalc(listPrice, zipCode, hoaDues) {

        let config = {};

        if (isFHA) {
            config = {
                list_price: listPrice,
                loan_type: "FHA",
                down_payment: listPrice * downPaymentPercentage,
                zipcode: zipCode,
                hoaDues
            };
        } else {
            config = {
                list_price: listPrice,				
                loan_type: "conventional",				
                down_payment: listPrice * downPaymentPercentage,
                zipcode: zipCode,
                hoaDues
            };
        }

        BB.api.setConfig(config)
        BB.api.openModal('mortgageCalc')
    }

    return (
        <div className={`century-card product-card card ${markerDataState?.activeResult?.name === name ? 'active' : ''}`} id={name} role="group" aria-label="Community">
        <div className='special-offer-icon'>
            {offerFlags && offerFlags.map((flag, index) => (
                <span key={index} className={`flags-icon ${flag.flagBgColor}`}>
                    {flag.flagText}
                </span>
            ))}
        </div>
        <img className="card-img-top" src={imageUrl || settings.communityPlaceholderImageUrl} alt="" width="448" height="300" loading="lazy" />
        <div className='card-body'>
            <div className='card-header'>
                <h2 className='card-title'>
                    <a href={url}>{name}</a>
                </h2>
                <p className='address'>
                    {cityStateZip}
                </p>
                <p className='phone'>
                <a href={"tel:" + phoneNumber}>{phoneNumber}</a>
            </p>
            </div>
            <div className='card-text'>
                <div className='price-wrapper'>
                    <div className='starting-price'>
                        {startingPrice > 0 && (
                            <>
                                <span className="start-from">{labels.homesFromLabel}</span>
                                <span className="price">${Math.round(startingPrice).toLocaleString()}</span>
                            </>
                        )}
                        {startingPrice === 0 && (
                            <span className="price-only">{priceOverrideText}</span>
                        )}
                    </div>
                </div>
            </div>
        </div>
        <div className='bottom-row'>

            <div className='bottom-border-logo'>
                {company === Brands.CENTURY_COMPLETE ? (
                    <img src={settings.centuryCompleteBrandImageUrl} alt='Century Complete Logo' loading="lazy" />
                ) : (
                    <img src={settings.centuryCommunityBrandImageUrl} alt='Century Communities Logo' loading="lazy" />
                )}
            </div>

            {!isHidingMonthlyPayment && startingPrice > 0 && (
                <div className="est-payment">
                    <div className='per-month-price'>
                        <span className="monthly-payment-container" ref={spanEl}>
                            <small>Est.</small>
                            {isMortCalcEnabled ? (
                                <>
                                    {monthlyPayment === "" && (
                                        <span className="spinner-border" role="status"><span className="sr-only">Loading...</span></span>
                                    )}
                                    {settings.disableBankingBridgeCalculatorModal == 'true' ? (
                                        <span className="monthly-payment">
                                            {monthlyPayment.toLocaleString('en-US', { style: 'currency', currency: 'USD' }).replace('.00', '')}
                                            <span className='sr-only'> Open Mortage Calculator</span>
                                        </span>
                                    ) : (
                                        <button className="monthly-payment" onClick={() => openCalc(housePrice, zipCode, hoaDues)}>
                                            {monthlyPayment.toLocaleString('en-US', { style: 'currency', currency: 'USD' }).replace('.00', '')}
                                            <span className='sr-only'> Open Mortage Calculator</span>
                                        </button>
                                    )}
                                </>
                            ) : <span className="monthly-payment">{financeInfo.monthlyPayment}</span>}
                            <small>/mo</small>
                            {settings.disableBankingBridgeCalculatorModal == 'false' && (
                                <button onClick={() => openCalc(housePrice, zipCode, hoaDues)}>
                                    <span className="fa-solid fa-circle-info" aria-hidden="true"></span>
                                    <span className="sr-only">Open Mortgage Calculator</span>
                                </button>
                            )}
                        </span>
                    </div>
                </div>
            )}

        </div>
    </div>

    );
};

export default CommunityResult;
